import { UsersPage } from '@vxui/common';
import { Navigate, Route, createRoutesFromElements } from 'react-router-dom';
import { App } from './App';
import { Dashboard } from './pages';

export const routes = createRoutesFromElements(
  <Route handle="navigation.index" path="/" element={<App />}>
    <Route index element={<Dashboard />} />
    <Route path="users" element={<UsersPage />} />
    <Route path="*" element={<Navigate to="/" />} />
  </Route>,
);
